import React from "react";
import { observer, inject } from "mobx-react";
import { Menu } from "antd";
import "antd/dist/antd.css";
import AddressInfo from "./AddressInfo";
//const alert = Modal.alert;
//import { FiEdit } from "react-icons/fi";

//const { SubMenu } = Menu;
@inject("cartStore")
@observer
class CocoMenuSide extends React.Component {
  transformMenuName = (item) => {
    let itemName = item;
    try {
      if (!item) return itemName;

      // Use regular expressions to match alphabet characters and Chinese characters
      const alphabetMatches = item.match(/[a-zA-Z\s]+/g);
      const chineseMatches = item.match(/[\u4e00-\u9fa5]+/g);

      const alphabetChars = alphabetMatches
        ? alphabetMatches.join("").trim()
        : "";
      const chineseChars = chineseMatches ? chineseMatches.join("").trim() : "";

      // Only create a divided display if we have both types of characters
      if (alphabetChars && chineseChars) {
        itemName = (
          <div>
            {alphabetChars}
            <br />
            {chineseChars}
          </div>
        );
      }
    } catch (error) {
// console.log("Error parsing item name:", error);
    }
    return itemName;
  };

  renderCocoHorizontalMenu = (data) => {
    let promolength = this.props.cartStore.menuStore.promotionsLength;
    return (
      <React.Fragment>
        {data.map((item, index) => {
          let active = "drawermenu";
// console.log(
//             "activePromo",
//             this.props.cartStore.menuStore.activePromo
//           );
// console.log(
//             "PromoMenuKey",
//             this.props.cartStore.menuStore.PromoMenuKey
//           );
          // Sử dụng horizontalMenuSelectedIndex để xác định active state thay vì activePromo
          const currentSelectedIndex = this.props.cartStore.menuStore.horizontalMenuSelectedIndex;
          if (currentSelectedIndex && currentSelectedIndex.length > 0 && parseInt(currentSelectedIndex[0]) === index) {
            active = "drawermenu active";
          }
          const itemName = this.transformMenuName(item);
          return (
            <div
              className={active}
              style={{ cursor: "pointer" }}
              key={index}
              id={"sidemenucoco" + index}
              onClick={(obj) => {
                let key = parseInt(obj.key);
// console.log("key", key);
                const targetElement = document.getElementById(item);
                if (targetElement) {
                  targetElement.scrollIntoView();
                } else {
                  console.warn(`⚠️ [Drawer] Could not find element with id "${item}" - it may be filtered out by search`);
                }
                this.props.cartStore.menuStore.horizontalMenuSelectedIndex = [
                  key.toString(),
                ];
                // KHÔNG cập nhật activePromo khi click vào category
                // this.props.cartStore.menuStore.activePromo = index;
                // this.props.cartStore.menuStore.PromoMenuKey = index;

                // Center the selected menu item
                setTimeout(() => {
                  const selectedItem =
                    document.querySelector(".drawermenu.active");
                  if (selectedItem) {
                    selectedItem.scrollIntoView({
                      block: "center",
                      inline: "center",
                      behavior: "smooth",
                    });
                  }
                }, 500);

                this.props.onClose();
              }}
            >
              {itemName}
            </div>
          );
        })}
      </React.Fragment>
    );
  };
  renderCocoHorizontalPromos = () => {
    let promolength = this.props.cartStore.menuStore.promotionsLength;
    let data = this.props.cartStore.menuStore.promotions;
    if (promolength === 0) {
      return "";
    }
    return (
      <React.Fragment>
        {data.map((item, index) => {
          let active = "drawermenu";
          if (this.props.cartStore.menuStore.PromoMenuKey == index) {
            active = "drawermenu active";
          }
          const itemName = this.transformMenuName(item);
          return (
            <div
              className={active}
              style={{ cursor: "pointer" }}
              key={index}
              onClick={(obj) => {
                this.props.cartStore.menuStore.horizontalMenuSelectedKey = item;
                this.props.cartStore.menuStore.activePromo = index;
                this.props.cartStore.menuStore.PromoMenuKey = index;
                this.props.cartStore.menuStore.resetMeuList();
                this.props.cartStore.menuStore.searchResult =
                  this.props.cartStore.menuStore.filterMenuList;

                // Set flag to temporarily disable scroll detection
                window.promoJustClicked = true;
                setTimeout(() => {
                  window.promoJustClicked = false;
// console.log("🔄 [Drawer] Re-enabled scroll detection after promo click");
                }, 2000); // Disable for 2 seconds

                // Scroll to first category of the selected promotion
                setTimeout(() => {
                  const newHorizontalCategoryList = this.props.cartStore.menuStore.horizontalCategoryList;
                  if (newHorizontalCategoryList && newHorizontalCategoryList.length > 0) {
                    const firstCategory = newHorizontalCategoryList[0];
                    const categoryElement = document.getElementById(firstCategory);
                    if (categoryElement) {
// console.log(`🎯 [Drawer] Scrolling to first category "${firstCategory}" of promo "${item}"`);
                      categoryElement.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    } else {
                      console.warn(`⚠️ [Drawer] Could not find element with id "${firstCategory}"`);
                    }
                  } else {
                    console.warn(`⚠️ [Drawer] No categories found for promo "${item}"`);
                  }
                }, 100);

                // Center the selected menu item
                setTimeout(() => {
                  const selectedItem =
                    document.querySelector(".drawermenu.active");
                  if (selectedItem) {
                    selectedItem.scrollIntoView({
                      block: "center",
                      inline: "center",
                      behavior: "smooth",
                    });
                  }
                }, 500);

                this.props.onClose();
              }}
            >
              {itemName}
            </div>
          );
        })}
      </React.Fragment>
    );
  };
  render() {
    let data = this.props.cartStore.menuStore.horizontalCategoryList;
    return (
      <React.Fragment>
        {this.renderCocoHorizontalPromos()}
        {this.renderCocoHorizontalMenu(data)}
      </React.Fragment>
    );
  }
}

export default CocoMenuSide;
